import request from '@/utils/request'


// 查询政策条款列表
export function listMsgPolicyTerms(query) {
  return request({
    url: '/msg/msg/policy/terms/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询政策条款分页
export function pageMsgPolicyTerms(query) {
  return request({
    url: '/msg/msg/policy/terms/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询政策条款详细
export function getMsgPolicyTerms(data) {
  return request({
    url: '/msg/msg/policy/terms/detail',
    method: 'get',
    params: data
  })
}

// 新增政策条款
export function addMsgPolicyTerms(data) {
  return request({
    url: '/msg/msg/policy/terms/add',
    method: 'post',
    data: data
  })
}

// 修改政策条款
export function updateMsgPolicyTerms(data) {
  return request({
    url: '/msg/msg/policy/terms/edit',
    method: 'post',
    data: data
  })
}

// 删除政策条款
export function delMsgPolicyTerms(data) {
  return request({
    url: '/msg/msg/policy/terms/delete',
    method: 'post',
    data: data
  })
}
